// Clock-injectable age helpers for the Meta placement report (twin of summarizeReport in
// proxy-server/sdkBidding/placements.js: whole days since window.to, stale when > 30).
const DAY_MS = 86400000;
export const STALE_DAYS = 30;

export function reportAgeDays(windowTo, nowMs) {
  const to = Date.parse(`${windowTo}T00:00:00Z`);
  if (!Number.isFinite(to)) return null;
  const now = Number.isFinite(Number(nowMs)) ? Number(nowMs) : Date.now();
  return Math.floor((now - to) / DAY_MS);
}

export function isReportStale(entry, nowMs) {
  const age = reportAgeDays(entry && entry.window ? entry.window.to : null, nowMs);
  return age != null && age > STALE_DAYS;
}
